function civicChangeHeadings() {
    setTimeout(function () {
    const $cccontainer = $('#ccc');
    if ($cccontainer.length === 0) return;

    const observer = new MutationObserver((mutationsList) => {
        mutationsList.forEach(() => {
            const $h3headings = $('h3.optional-cookie-header'); 
            if ($h3headings.length) {
            $($h3headings).each(function () {
                const $this = $(this);
                if (!$this.prev().is('h2.lbih2')) {
                    const headingText = $.trim($this.text());
                    $('<h2>', {
                        class: 'lbih2',
                        text: headingText
                    }).insertAfter($this);
                }
                $this.remove();
            });
        }
        });
    });

    observer.observe($cccontainer[0], {
        childList: true,
        subtree: true
    });
    }, 1000); // end timeout
}									
function civicCheckConsentCategories() {
    setTimeout(function () {
        if (typeof window.clarity !== 'function') {
            return;
        }

        const analytics = CookieControl.getCategoryConsent(0);
        const advertising = CookieControl.getCategoryConsent(1);

        if (analytics && advertising) {
            window.clarity('consentv2', {
                analytics_Storage: "granted",
                ad_Storage: "granted",
            });
            console.log("analytics granted, ad granted");
        }
        else if (analytics && !advertising) {
            window.clarity('consentv2', {
                analytics_Storage: "granted",
                ad_Storage: "denied",
            });
            console.log("analytics granted, ad denied");
        }
        else if (!analytics && advertising) {
            window.clarity('consentv2', {
                analytics_Storage: "denied",
                ad_Storage: "granted",
            });
            console.log("analytics denied, ad granted");
        }
        else {
            window.clarity('consentv2', {
                analytics_Storage: "denied",
                ad_Storage: "denied",
            });
            console.log("analytics denied, ad denied");
        }
    }, 1000); // end timeout	
}
    var config = {
        apiKey: 'fbb8dc650d938720810351158cde7363681aa845',
        product: 'PRO_MULTISITE',
        necessaryCookies: ['ARRAffinity', 'hideCookieBanner'],
        initialState: 'CLOSED',
        subDomains: false,
        //closeStyle: "button",
        //toggleType: 'checkbox',
        theme: 'LIGHT',
        position: "LEFT",
        layout: "SLIDEOUT",
        logConsent: true,
        text: {
            title: 'Set your cookie preferences',
            intro: 'This site uses cookies. Make your choices below.',
            necessaryTitle: 'Essential cookies',
            necessaryDescription: 'Some of our cookies are essential and parts of the site won\'t work without them. These cookies are set when you submit a form, login to My eAccount or use the interactive maps.',
            accept: "Accept",
            //reject: "Reject",
            acceptSettings: "Accept all cookies",
            rejectSettings: "Reject all cookies",
            closeLabel: "Close",
            settings: 'Set cookie preferences',
            on: 'ON',
            off: 'OFF',
            notifyTitle: 'We use cookies on this site',
            notifyDescription: 'If you don\'t want to accept cookies, you can change your preferences'
        },
        statement: {
            description: 'For more information and to find out how to delete or disable cookies, visit our',
            name: 'cookies page',
            url: '/legal-information/cookies',
            updated: '10/10/2025'
        },
        accessibility: {
            //highlightFocus: true,
            outline: true,
            overlay: false
        },
        branding: {
            fontFamily: "'Poppins', Arial, sans-serif",
            fontColor: "#222222",
            fontSizeTitle: "1.5em",
            fontSizeIntro: "1.2em",
            fontSizeHeaders: "1.2em",
            fontSize: "0.95em",
            backgroundColor: "#DDD6CA",
            toggleColor: "#000",
            toggleBackground: "#FFF",
            removeAbout: true,
            acceptText: "#FFF",
            acceptBackground: "#000"
        },
        optionalCookies: [
            {
                name: 'analytics',
                label: 'Analytics',
                description: 'Analytical cookies help us to improve our website by collecting and reporting information on its usage.',
                cookies: ['_ga', '_gid', '_gat', '__utma', '__utmt', '__utmb', '__utmc', '__utmz', '__utmv', 'SC_ANALYTICS_GLOBAL_COOKIE', 'nmstat', '_clck', '_clsk', 'CLID',],
                onAccept: function () {
                    // Google Tag Manager
                    (function (w, d, s, l, i) {
                        w[l] = w[l] || []; w[l].push({
                            'gtm.start':
                                new Date().getTime(), event: 'gtm.js'
                        }); var f = d.getElementsByTagName(s)[0],
                            j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                                'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
                    })(window, document, 'script', 'dataLayer', 'GTM-PG8V8KC');
                    // send analytics consent to Clarity API

                    civicCheckConsentCategories()
                },
                onRevoke: function () {
                    // Disable Google Analytics
                    window['ga-disable-UA-61395129-1'] = true;
                    // End disable Google Analytics
                    CookieControl.delete("nmstat");
                    $.cookie("hideCookieBanner", true, { expires: 365, path: "/" });
                    // revoke analytics consent to Clarity API
                    civicCheckConsentCategories()

/*                        console.log("cc analytics denied");*/

                },
                recommendedState: "ON"
            },
            {
                name: 'advertising',
                label: 'Advertising',
                description: 'Marketing cookies are used to track the performance of our marketing campaign.',
                cookies: ['ANONCHK', 'MR', 'MUID', 'SM'],
                onAccept: function () {
                    // send ad consent to Clarity API
                    civicCheckConsentCategories()
                },
                onRevoke: function () {
                    // revoke ad consent to Clarity API
                    civicCheckConsentCategories()
                },
                recommendedState: "ON"
            },
            {
                name: 'preferences',
                label: 'Preferences',
                description: 'We use some cookies to record your preferences, such as whether you want to display alerts on the site.',
                cookies: ['preferences', 'Announcements_*', 'hideCookieBanner'],
                onAccept: function () {
                    // alerts added in mando.alerts.js
                    // Mando cookie banner close cookie
                    $.cookie("hideCookieBanner", true, { expires: 365, path: "/" });

                },
                onRevoke: function () {
                    CookieControl.delete("preferences");
                    CookieControl.delete("Announcements_*");
                    localStorage.removeItem("UKISLINGTON_subscribe_overlay");
                    $.cookie("hideCookieBanner", true, { expires: 365, path: "/" });
                },
                recommendedState: "ON"
            }
        ]
    };
    CookieControl.load(config);
    civicChangeHeadings()
